import { render } from "./SectionTableManagement.vue?vue&type=template&id=74c3ed2c&scoped=true"
import script from "./SectionTableManagement.vue?vue&type=script&lang=js"
export * from "./SectionTableManagement.vue?vue&type=script&lang=js"

import "./SectionTableManagement.vue?vue&type=style&index=0&id=74c3ed2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c3ed2c"]])

export default __exports__